import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import {
	PrimaryProductKeys,
	ProductKeys,
	useProductConfigs,
} from '../../common/constants/products';
import { usePrimaryProduct } from '../store/bootstrap';

const styles = cssMap({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.050'),
	},
	iconBox: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '16px',
		height: '16px',
		overflow: 'hidden',
		borderRadius: token('radius.small'),
		flexShrink: 0,
	},
});

/**
 * Renders a strip of 3 app icons: the primary 1P app icon (Confluence if Jira,
 * Jira otherwise) followed by static Google Drive and Slack icons.
 */
export const AllAppsIcon = (): React.JSX.Element => {
	const [primaryProduct] = usePrimaryProduct();
	const productConfigs = useProductConfigs();

	const FirstPartyIcon =
		primaryProduct === PrimaryProductKeys.Jira
			? productConfigs[ProductKeys.Confluence]?.Icon
			: productConfigs[ProductKeys.Jira]?.Icon;

	const icons = [
		FirstPartyIcon,
		productConfigs[ProductKeys3P.GoogleDrive]?.Icon,
		productConfigs[ProductKeys3P.Slack]?.Icon,
	].filter(Boolean) as NonNullable<typeof FirstPartyIcon>[];

	return (
		<Flex role="presentation" aria-hidden="true" xcss={styles.container}>
			{icons.map((Icon, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<Box key={index} xcss={styles.iconBox}>
					<Icon size="xxsmall" />
				</Box>
			))}
		</Flex>
	);
};
